const STATUS_CLASSES = {
  approvato: "bg-[#2E8A57]/10 text-[#2E8A57]",
  rifiutato: "bg-red-50 text-red-700",
};
const statusClass = (s) => STATUS_CLASSES[s] || "bg-[#7DC242]/15 text-[#3C6E53]";

export const AdminB2BTab = ({ accounts, settings, onUpdateAccount, onUpdateSettings }) => (
  <div className="space-y-4">
    <div className="rounded-2xl border border-[#E7E0D8] bg-white p-5 flex flex-wrap items-center gap-6" data-testid="admin-b2b-settings">
      <p className="font-mono-accent text-[10px] uppercase tracking-[0.2em] text-[#2E8A57]">Impostazioni B2B</p>
      <label className="flex items-center gap-2 text-sm">
        Ordine minimo €
        <input data-testid="admin-b2b-min-order" type="number" min="0" step="10" defaultValue={settings.min_order}
          onBlur={(e) => { const v = parseFloat(e.target.value); if (!isNaN(v) && v !== settings.min_order) onUpdateSettings({ min_order: v }); }}
          className="w-24 rounded-lg border border-[#E7E0D8] px-3 py-1.5" />
      </label>
      <label className="flex items-center gap-2 text-sm">
        Pezzi per cartone
        <input data-testid="admin-b2b-carton" type="number" min="1" max="100" defaultValue={settings.carton_qty}
          onBlur={(e) => { const v = parseInt(e.target.value); if (!isNaN(v) && v !== settings.carton_qty) onUpdateSettings({ carton_qty: v }); }}
          className="w-20 rounded-lg border border-[#E7E0D8] px-3 py-1.5" />
      </label>
    </div>
    {accounts.length === 0 && <p data-testid="admin-no-b2b" className="text-[#78716C]">Nessuna richiesta rivenditore.</p>}
    {accounts.map((a) => (
      <div key={a.id} data-testid={`admin-b2b-${a.id}`} className="rounded-2xl border border-[#E7E0D8] bg-white p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <p className="font-semibold">{a.company}</p>
          <p className="text-sm text-[#78716C]">P.IVA {a.vat} · {a.email}{a.phone ? ` · ${a.phone}` : ""}</p>
          <p className="font-mono-accent text-xs text-[#78716C] mt-1">{new Date(a.created_at).toLocaleString("it-IT")}</p>
        </div>
        <div className="flex items-center gap-3">
          <label className="font-mono-accent text-[10px] uppercase tracking-wide text-[#78716C]">Sconto %</label>
          <input
            data-testid={`admin-b2b-discount-${a.id}`}
            type="number" min="0" max="90" step="1" defaultValue={a.discount ?? 30}
            onBlur={(e) => { const v = parseFloat(e.target.value); if (!isNaN(v) && v !== (a.discount ?? 30)) onUpdateAccount(a.id, undefined, v); }}
            className="w-20 rounded-lg border border-[#E7E0D8] px-3 py-1.5 text-sm"
          />
          <span className={`rounded-full px-4 py-1.5 text-xs font-semibold ${statusClass(a.status)}`}>{a.status}</span>
          {a.status !== "approvato" && (
            <button data-testid={`admin-b2b-approve-${a.id}`} onClick={() => onUpdateAccount(a.id, "approvato")} className="btn-tuscan px-5 py-2 rounded-full text-xs font-semibold">Approva</button>
          )}
          {a.status !== "rifiutato" && (
            <button data-testid={`admin-b2b-reject-${a.id}`} onClick={() => onUpdateAccount(a.id, "rifiutato")} className="px-5 py-2 rounded-full text-xs font-semibold border border-[#E7E0D8] hover:border-red-400 hover:text-red-600 transition-colors">Rifiuta</button>
          )}
        </div>
      </div>
    ))}
  </div>
);
